/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".modal-header[_ngcontent-%COMP%]{background-color:#0080ff;color:#fff;font-size:1.5rem}.modal-header[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]{background:transparent;border:0;outline:none;cursor:pointer}.modal-footer[_ngcontent-%COMP%]   button[_ngcontent-%COMP%], .modal-header[_ngcontent-%COMP%]   .close-btn[_ngcontent-%COMP%]   span[_ngcontent-%COMP%]{color:#fff}"];
export { styles as styles };
//# sourceMappingURL=personal-photo.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/preferences/personal-photo/personal-photo.component.scss.shim.ngstyle.js
// module id = 1350
// module chunks = 26 27 28